export default "/vendor/glyphicons-halflings-regular.e3cab037268b4e02bef8397a8ba62a78.woff";